import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewDecisionTreeModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewDecisionTreeModal: React.FC<ViewDecisionTreeModalProps> = ({ open, onClose }) => {
  const { selectedTree, loading } = useAppSelector((state) => state.decisionTrees);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Detalle de Árbol de Decisiones</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedTree ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Clave
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTree.treeKey}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Nombre
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTree.name}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Descripción
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTree.description || '(vacío)'}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Icono
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTree.icon}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Orden de Visualización
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTree.displayOrder}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Activo
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTree.isActive ? 'Sí' : 'No'}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Creación
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTree.createdAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Creado Por
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTree.createdBy}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Actualización
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedTree.updatedAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Actualizado Por
              </Typography>
              <Typography variant="body1">
                {selectedTree.updatedBy}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography>No hay árbol seleccionado</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewDecisionTreeModal;
